import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FC, ReactNode } from 'react';

interface WidgetCardProps {
  title: string;
  children: ReactNode;
}

/** Shared white card shell for the community right-sidebar widgets. */
export const WidgetCard: FC<WidgetCardProps> = ({ title, children }) => (
  <Box
    sx={{
      bgcolor: '#fff',
      borderRadius: 4,
      boxShadow: '0 8px 10px rgba(0,0,0,0.04)',
      px: 2,
      py: 2,
      flexShrink: 0,
    }}
  >
    <Typography
      sx={{
        fontFamily: "'Figtree', sans-serif",
        fontWeight: 700,
        fontSize: 14,
        color: '#1a1a2e',
        letterSpacing: '-0.2px',
        mb: 1.5,
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);

/** Muted placeholder line for a widget with no data yet. */
export const WidgetEmpty: FC<{ children: ReactNode }> = ({ children }) => (
  <Typography sx={{ fontFamily: "'Figtree', sans-serif", fontSize: 13, color: '#9a9a9a', py: 0.5 }}>
    {children}
  </Typography>
);
